// extracted by mini-css-extract-plugin
var _1 = "jmlVd";
var _2 = "JoyqW";
export { _1 as "pageContentWrapper", _2 as "pageImage" }
